const SellerFilters = () => {
  return (
    <>
      <div className=" display-max">
        <div className=" me-1 mt-3">
          <b className=" text-dark ">Category</b>
          <div className=" text-nowrap mb-2">
            <div className=" p-1">
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>{" "}
                  Baby
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>{" "}
                  Bags, Wallets and Luggage
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Beauty
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Books
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Car & Motorbike
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Clothing & Accessories
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Computers & Accessories
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Electronics
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Fashion
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Grocery & Gourmet Foods
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Health & Personal Care
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Home & Kitchen
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Home Improvement
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Industrial & Scientific
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Jewellery
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Musical Instruments
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Office Products
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Outdoor Living
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Shoes & Handbags
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Software
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Sports, Fitness & Outdoor
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Toys & Games
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  <i className="bi bi-chevron-left text-xs text-black me-1"></i>
                  Video Games
                </a>
              </div>
            </div>
          </div>
          <b className=" text-dark ">Customer Review</b>
          <div className="text-nowrap mb-2">
            <div className=" p-1">
              <div className="form-check mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="fcustomCheck1"
                />
                <label className="text-sm fw-normal text-dark ms-2">
                  4<i className="bi bi-star-fill text-dark text-xs ms-1"></i> &
                  above
                </label>
              </div>
              <div className="form-check mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="fcustomCheck1"
                />
                <label className="text-sm fw-normal text-dark ms-2">
                  3<i className="bi bi-star-fill text-dark text-xs ms-1"></i> &
                  above
                </label>
              </div>
              <div className="form-check mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="fcustomCheck1"
                />
                <label className="text-sm fw-normal text-dark ms-2">
                  2<i className="bi bi-star-fill text-dark text-xs ms-1"></i> &
                  above
                </label>
              </div>
            </div>
          </div>
          <b className=" text-dark ">Deals & Discounts</b>
          <div className=" text-nowrap mb-2">
            <div className=" p-1">
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  All Discounts
                </a>
              </div>
              <div>
                <a
                  href="/SubCategorie"
                  className=" text-sm fw-normal text-dark"
                >
                  Today's Deals
                </a>
              </div>
            </div>
          </div>
          <b className=" text-dark ">Availability</b>
          <div className="text-nowrap mb-2">
            <div className=" p-1">
              <div className="form-check mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="fcustomCheck1"
                />
                <label className="text-sm fw-normal text-dark ms-2">
                  Include out of stock
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" display-mini display-mob"></div>
    </>
  );
};

export default SellerFilters;
